import { css } from '@emotion/react'

const S = {
  basic: css`
    height: auto;
    > path {
      fill: currentColor;
    }
  `,
}

export default S
